import React from 'react';
import { SOCIAL_SENTIMENT_DOMAINS, USER_PLANS } from 'config/appConfig';
import { lazy } from 'react';
import StockTwits from 'assets/images/StockTwits.svg';

const socialSentimentChildren = [
  {
    path: '/socialSentiment',
    label: 'Twitter',
    domain: SOCIAL_SENTIMENT_DOMAINS.GENERAL,
    icon: () => (
      <span
        style={{
          fontSize: '1.4rem',
          userSelect: 'none',
          lineHeight: '1rem',
        }}>
        𝕏
      </span>
    ),
    license: USER_PLANS.noLicenseNeeded,
  },
  {
    path: `/socialSentiment?domain=${SOCIAL_SENTIMENT_DOMAINS.REDDIT}`,
    label: 'Reddit',
    domain: SOCIAL_SENTIMENT_DOMAINS.REDDIT,
    icon: lazy(() => import('@material-ui/icons/Reddit')),
    license: USER_PLANS.noLicenseNeeded,
  },
  {
    path: `/socialSentiment?domain=${SOCIAL_SENTIMENT_DOMAINS.STOCKTWITS}`,
    label: 'Stocktwits',
    domain: SOCIAL_SENTIMENT_DOMAINS.STOCKTWITS,
    icon: () => <img src={StockTwits} alt="-" style={{ width: '100%', height: '100%' }} />,
    license: USER_PLANS.noLicenseNeeded,
  },
];

export default [
  {
    path: '/filings',
    label: 'Overview',
    icon: lazy(() => import('@material-ui/icons/DashboardTwoTone')),
    disabled: false,
    license: USER_PLANS.udt,
  },
  {
    path: '/comparision',
    label: 'Comparison',
    icon: lazy(() => import('@material-ui/icons/CalendarToday')),
    disabled: false,
    license: USER_PLANS.udt,
  },
  {
    path: '/sentiment',
    label: 'View Document',
    icon: lazy(() => import('@material-ui/icons/SettingsOutlined')),
    disabled: false,
    license: USER_PLANS.udt,
  },
  {
    path: '/socialSentiment',
    label: 'Social Sentiment',
    icon: lazy(() => import('@material-ui/icons/Message')),
    disabled: false,
    children: socialSentimentChildren,
    license: USER_PLANS.udt,
  },
  {
    path: '/news',
    label: 'News',
    icon: lazy(() => import('@material-ui/icons/Assignment')),
    disabled: false,
    license: USER_PLANS.udt,
  },
];
